// day/index.jsx

import React, { useEffect, useState } from 'react';
import { formatDate } from '@/utils/func';

const Day = (props) => {
  const {
    selected,
    onDayLongPress,
    onClick,
    value,
    markIndex,
    extraInfoIndex,
    customStyleGenerator,
    disable,
    isInRange,
    rangeStart,
    rangeEnd,
    isMultiSelectAndFinish,
    selectedDateColor,
    markColor,
    markSize,
    extraInfoColor,
    extraInfoSize,
    extraInfoText,
    showDivider,
  } = props;
  const [className, setClassName] = useState(['calendar-day']);
  const [customStyles, setCustomStyles] = useState({});

  useEffect(() => {
    let set = ['calendar-day'];
    const today = formatDate(new Date());
    if (!value.currentMonth || disable) {
      // 非本月
      set.push('not-this-month');
    }
    if (isInRange) {
      set.push('calendar-range');
    }

    if (rangeStart) {
      set.push('calendar-range-start');
    }

    if (rangeEnd) {
      set.push('calendar-range-end');
    }

    if (disable) {
      set.push('calendar-disabled'); // 添加禁用样式
    }
    if (markIndex !== -1) {
      set.push('calendar-marked');
    }

    if (selected) {
      set.push('calendar-selected');
    }

    setClassName(set);
  }, [
    disable,
    extraInfoIndex,
    isMultiSelectAndFinish,
    markIndex,
    selected,
    showDivider,
    value.currentMonth,
    value.fullDateStr,
    isInRange,
    rangeStart,
    rangeEnd,
  ]);

  useEffect(() => {
    if (customStyleGenerator) {
      // 用户定制样式
      const generatorParams = {
        ...value,
        selected: selected,
        multiSelect: {
          multiSelected: isInRange,
          multiSelectedStar: rangeStart,
          multiSelectedEnd: rangeEnd,
        },
        marked: markIndex !== -1,
        hasExtraInfo: extraInfoIndex !== -1,
      };
      setCustomStyles(customStyleGenerator(generatorParams));
    }
  }, [
    selected,
    value,
    markIndex,
    extraInfoIndex,
    customStyleGenerator,
    isInRange,
    rangeStart,
    rangeEnd
  ]);

  return (
    <div
      // onLongPress={
      //   onDayLongPress
      //     ? () => onDayLongPress({ value: value.fullDateStr })
      //     : undefined
      // }
      className={className.join(' ')}
      onClick={() => {
        if (!disable) {
          onClick(value);
        }
      }}
      style={customStyles.containerStyle}
    >
      <div
        className='calendar-date'
      // style={
      //   customStyles.dateStyle || customStyles.dateStyle === {}
      //     ? customStyles.dateStyle
      //     : {
      //       backgroundColor: selected || isInRange ? selectedDateColor : '',
      //     }
      // }
      >
        {/* 日期 */}
        {value.date}
      </div>
    </div>
  );
};

export default React.memo(Day);